import { render, staticRenderFns } from "./CompanyMore.vue?vue&type=template&id=18166c29&scoped=true"
import script from "./CompanyMore.vue?vue&type=script&lang=js"
export * from "./CompanyMore.vue?vue&type=script&lang=js"
import style0 from "./CompanyMore.vue?vue&type=style&index=0&id=18166c29&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18166c29",
  null
  
)

export default component.exports